import React, {Component} from 'react';
import {getAverageByForm} from "../../services/api/statistics";
import OitStatistics from "./OitStatistics";
import classNames from "classnames";
import * as XLSX from "dep-xlsx-js-style";

class OitRatingStatistics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      isFullscreen: false,
      isPrint: false
    }

    this.afterPrint = this.afterPrint.bind(this)
  }

  componentDidMount() {
    this.initializeData()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevProps.oits.length !== this.props.oits.length) {
      this.initializeData()
    } else if(this.numberOfSelectedPhases(prevProps.selectedPhasesMap) !== this.numberOfSelectedPhases(this.props.selectedPhasesMap)) {
      this.initializeData()
    } else if(prevProps.formTypes && prevProps.formTypes.length !== this.props.formTypes.length) {
      this.initializeData()
    }
  }

  numberOfSelectedPhases(selectedPhaseMap) {
    return Object.values(selectedPhaseMap).filter(v => v).length
  }

  initializeData() {
    this.getRatingByDepartment()
      .then((data) => Promise.all([
        this.transformData(data, "Department avg"),
        Promise.all(this.props.oits.map((oit, index) =>
          this.getRatingByUser(oit.guid).then(data => this.transformData(data, oit.getFullName()))))
      ]).then(([departmentAvg, usersAvg]) => [
        departmentAvg,
        ...usersAvg,
      ])).then(data => {
        console.log('initializeData', data)
      this.setState({data})
    })
  }

  transformData(data, id) {
    let dataMapped = data.reduce((acc, d) => ({
      ...acc,
      [d.question_id]:d
    }), {});

    return {
      id,
      data: this.questionsSorted.map(q => ({
        x: (q.ratingPrompt || q.prompt).split(/(\r\n|\r|\n|\s-)/)[0],
        y: dataMapped[q.id] ? dataMapped[q.id].average: 0
      }))
    }
  }

  getRatingByUser(oitGuid) {
    return getAverageByForm({
      user_guid: oitGuid,
      questions: this.questionIds,
      phase_sequence: this.selectedPhases,
      type: this.props.formTypes || undefined
    }).then((data) => {
      return data
    })
  }

  getRatingByDepartment() {
    return getAverageByForm({
      // user_guid: oitGuid,
      questions: this.questionIds,
      phase_sequence: this.selectedPhases,
      type: this.props.formTypes || undefined
    }).then((data) => {
      return data;
    })
  }

  toggleFullscreen() {
    this.setState({
      isFullscreen: !this.state.isFullscreen
    })
  }

  printReport() {

    window.addEventListener('afterprint', this.afterPrint)
    this.setState({
      isPrint: true
    }, () => {
      window.print()
    })
  }

  afterPrint() {
    this.setState({
      isPrint: false
    })
    window.removeEventListener('afterprint', this.afterPrint)
  }

  exportReport() {
    const wb = XLSX.utils.book_new();
    let rows = this.state.data[0].data.map((d) =>([{v: d.x, t: 's'}]))
    rows.unshift([
      {v: '', t: 's'},
      ...this.state.data.map(d => ({v: d.id, t: 's'}))
    ])
    this.state.data.forEach((d) => {
      d.data.forEach((r, index) => {
        rows[index + 1].push({v: r.y, t: 'n'})
      })
    })

    const ws = XLSX.utils.aoa_to_sheet(rows);
    XLSX.utils.book_append_sheet(wb, ws, "Oit statistics");

    XLSX.writeFile(wb, "statistics.xlsx");

  }

  get selectedPhases() {
    return Object.keys(this.props.selectedPhasesMap)
      .filter(key => this.props.selectedPhasesMap[key]);
  }

  get questionIds() {
    return Object.keys(this.props.selectedQuestions)
  }

  get questionsSorted() {
    console.log('this.props.selectedQuestions', this.props.selectedQuestions)
    return Object.keys(this.props.selectedQuestions)
      .map((key) => this.props.selectedQuestions[key])
      .sort((q1, q2) => {
        let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
        let sortPropA = q1.ratingPrompt || q1.prompt
        let sortPropB = q2.ratingPrompt || q2.prompt
        return collator.compare(sortPropA, sortPropB);
      })
  }

  get firstQuestion() {
    return this.questionsSorted[0]
  }

  render() {
    return this.state.data.length ?
      <div className={classNames({
        'oit-rating-statistics': true,
        'form': true,
        'analytics-container': true,
        'fullscreen': this.state.isFullscreen,
        'print': this.state.isPrint
      })}
      style={{
        display: this.state.isPrint? 'block !important': ''
      }}
      >
        {!this.props.inline && <div className="toggle-fullscreen" onClick={() => this.toggleFullscreen()}>
          <i className="fa fa-arrows-alt"/>
        </div>}
        {!this.props.isSelf && <div className="user-name">

          {!this.props.inline && <button className="button danger small"
                   onClick={() => this.props.onRemove()}>
            <i className="fa fa-trash-o mr-2"/>
            Remove
          </button>}

          <button className="button edit small"
                  onClick={() => this.exportReport()}>
            <i className="fa fa-download mr-2"/>
            Export
          </button>
          <button className="button edit small"
                  onClick={() => this.printReport()}>
            <i className="fa fa-print mr-2"/>
            Print
          </button>
        </div>}
        <OitStatistics data={this.state.data} firstQuestion={this.firstQuestion}/>
      </div>
      : null
  }
}

export default OitRatingStatistics;
